<template>
  <div>
    <div class="row whole-network-tab">
      <!-- <header-tabs :tabs="tabs" @change="onTabChange" ref="tabName"></header-tabs> -->
      <div class="row">
        <div
          class="tab-item" 
          :class="{'tab-item-active': item === selectedOptionTab}" 
          v-for="(item, index) in tabs" 
          :key="index"
          @click="onTabChange(item)"
          >
          {{item}}
        </div>
        <div v-if="showImportantNewsUnread && selectedOptionTab === '事件细闻'" @click="onShowImportantNewMessage" class="row important-news-unread-message">
          <img src="../../assets/img/arrow-up.svg" class="icon" alt="">
          <span class="important-news-unread-count">{{latestImportantNewsData.length}}条新闻</span>
        </div>
      </div>
      <div v-if="selectedOptionTab === '事件细闻'" class="input-container">
        <input ref="input" type="text" placeholder="请输入新闻标题" v-model.trim="importantNewsSearchText" @keypress.enter="onRecommendImportantNewsSearch()">
        <img src="../../assets/img/search2.svg" @click="onRecommendImportantNewsSearch()" class="search-img" alt="">
      </div>
      <div v-if="selectedOptionTab === '事件机会'" class="row input-container">
        <input ref="input" type="text" placeholder="请输入事件标题" v-model.trim="eventSearchText" @keypress.enter="onRecommendEventSearch()">
        <img src="../../assets/img/search2.svg" @click="onRecommendEventSearch()" class="search-img" alt="">
        <el-select class="select" @change="onEventOptionChange" v-model="option" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"  
            :label="item.label"
            :value="item.value"
            ></el-option>
        </el-select>
        <el-checkbox v-model="eventAutoRefresh" @change="eventAutoRefreshChange"></el-checkbox>
        <span class="event-refresh-title"><span class="event-refresh-title-count">{{eventRefreshCountDown}}</span>秒后刷新</span>
        <img v-show="!eventLoading" @click="onEventAutoRefreshClick" class="refresh-icon" src="../../assets/img/eventLoading2.svg" alt="">
        <img v-show="eventLoading" class="refresh-icon-loading" src="../../assets/img/eventLoading1.gif" alt="">
      </div>
    </div>
    <div v-loading="isLoading" class="recommend-focus-news-list" v-show="selectedOptionTab === '事件细闻'">
      <div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <transition-group name="focus-list">
            <RecommendFocusNewsItem class="recommend-focus-news-item" v-for="(item, index) in focusNewsList" :key="index" :data="item"></RecommendFocusNewsItem>
          </transition-group>
        </div>
      </div>
      <div class="loading" v-if="itemData.length && focusNewsList.length && recommendNewsTotalCount>pageSize"><div class="loading-word">加载中...</div></div>
      <div class="loading" v-if="focusNewsList.length && !itemData.length || (recommendNewsTotalCount>0 && recommendNewsTotalCount<=pageSize)"><div class="loading-word">没有更多了</div></div>
      <div v-if="!recommendNewsTotalCount && !focusNewsList.length">
        <img class="recommend-no-data-img" src="../../assets/img/entity-news-no-data.svg" alt="">
        <div class="recommend-no-data-word">无搜索结果</div>
      </div>
    </div>
    <div v-loading="isLoading" class="recommend-event-news-list" :class="{'recommend-event-news-list-no-data': !recommendEventTotalCount}" v-show="selectedOptionTab === '事件机会'">
      <div>
        <div v-infinite-scroll="loadMoreEvent" infinite-scroll-disabled="eventBusy" infinite-scroll-distance="10">
          <RecommendEventNewsItem class="recommend-event-news-item-container" v-for="(item) in eventList" :key="item.eventId" :data="item"></RecommendEventNewsItem>
        </div>
      </div>
      <div class="loading" v-if="eventItemData.length && eventList.length && eventList.length > 15"><div class="loading-word">加载中...</div></div>
      <div class="loading" v-if="eventList.length && !eventItemData.length"><div class="loading-word">没有更多了</div></div>
      <div v-if="!recommendEventTotalCount && !eventList.length">
        <img class="recommend-no-data-img" src="../../assets/img/entity-news-no-data.svg" alt="">
        <div class="recommend-no-data-word">无搜索结果</div>
      </div>
    </div>
  </div>
</template>

<script>
import RecommendFocusNewsItem from '@/components/recommend/RecommendFocusNewsItem';
import RecommendEventNewsItem from '@/components/recommend/RecommendEventNewsItem';
import QuestionQuery from '@/rest/questionQuery';
import Mark from 'mark.js';

export default {
  name: 'recommend-news-list',
  data() {
    return {
      recommendNewsTotalCount: -1,
      recommendEventTotalCount: -1,
      eventHighLight: [],
      importantNewsHighLight: [],
      eventSearchText: '',
      importantNewsSearchText: '',
      latestImportantNewsTimer: null,
      latestImportantNewsData: [],
      showImportantNewsUnread: false,
      importantNewsDoc: null,
      eventId: -1,
      eventTimerFunction: null,
      eventRefreshCountDown: 60,
      eventAutoRefresh: true,
      eventPageNum: 1,
      eventPageSize: 20,
      isLoading: false,
      busy: false,
      timer: null,
      eventTimer: null,
      tabs: ['事件机会', '事件细闻'],
      selectedOptionTab: '事件机会',
      searchText: '',
      pageNum: 1,
      pageSize: 20,
      earliestNewsId: -1,
      earliestDateNum: -1,
      latestDateNum: -1,
      // latestNewsId: -1,
      itemData: [],
      focusNewsList: [],
      eventList: [],
      eventItemData: [],
      timer1: null,
      option: 'min_publish_date',
      options: [
        {
          value: 'heat',
          label: '事件热度'
        },
        {
          value: 'max_publish_date',
          label: '最新报道'
        },
        {
          value: 'min_publish_date',
          label: '首篇报道'
        }
      ],
      eventLoading: false
    };
  },
  methods: {
    onRecommendEventSearch() {
      this.eventPageNum = 1;
      this.eventId = -1;
      this.eventRefreshCountDown = 60;
      this.eventItemData = [];
      this.eventList = [];
      if (this.eventSearchText) {
        this.getRecommendEventSearch(false);
      } else {
        this.recommendEventTotalCount = -1;
        this.eventHighLight = [];
        this.getRecommendEvent(false);
      }
    },
    getRecommendEventSearch(getData = false) {
      this.isLoading = true;
      QuestionQuery.getRecommendEventSearch(this.eventPageNum, this.eventPageSize, this.eventSearchText, this.option).then(res => {
        if (this.eventLoading) {
          this.eventLoading = false;
        }
        this.isLoading = false;
        this.recommendEventTotalCount = res.totalCount;
        if (res.events.length) {
          if (getData) {
            this.eventItemData = [];
            this.eventList = [];
          }
          this.eventHighLight = res.highlight;
          this.eventItemData = res.events.map(item => {
            return {
              heat: item.heat,
              title: item.title,
              count: item.count,
              firstTime: item.min_publish_date,
              lastTime: item.max_publish_date,
              eventId: item.event_id,
              sentiment: item.sentiment,
              companies: item.companies
            };
          });
          for (let i = 0; i < this.eventItemData.length - 1; i++) {
            for (let j = i + 1; j < this.eventItemData.length; j++) {
              if (this.eventItemData[i].title === this.eventItemData[j].title) {
                this.eventItemData[i].companies = this.eventItemData[i].companies.concat(this.eventItemData[j].companies);
                for (let x = 0; x < this.eventItemData[i].companies.length - 1; x++) {
                  for (let y = x + 1; y < this.eventItemData[i].companies.length; y++) {
                    if (this.eventItemData[i].companies[x].name === this.eventItemData[i].companies[y].name) {
                      this.eventItemData[i].companies.splice(y, 1);
                      y--;
                    }
                  }
                }
                this.eventItemData.splice(j, 1);
                j--;
              }
            }
          }
          for (let m = 0; m < this.eventList.length - 1; m++) {
            for (let n = 0; n < this.eventItemData.length - 1; n++) {
              if (this.eventList[m].title === this.eventItemData[n].title) {
                this.eventItemData.splice(n, 1);
                n--;
              }
            }
          }
          this.eventList = this.eventList.concat(this.eventItemData);
          this.eventBusy = false;
        } else {
          this.eventItemData = [];
          this.eventBusy = true;
        }
      });
    },
    onRecommendImportantNewsSearch() {
      this.getLatestImportantNewsSetInterval(false);
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.pageNum = 1;
      this.itemData = [];
      this.focusNewsList = [];
      this.showImportantNewsUnread = false;
      this.latestImportantNewsData = '';
      if (this.importantNewsSearchText) {
        this.getRecommendImportantNewsSearch();
      } else {
        this.recommendNewsTotalCount = -1;
        this.importantNewsHighLight = [];
        this.getFirstEarliestImportantNews();
      }
    },
    getRecommendImportantNewsSearch() {
      this.isLoading = true;
      QuestionQuery.getRecommendImportantNewsSearch(this.pageNum, this.pageSize, this.importantNewsSearchText).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.importantNewsHighLight = res.highlight;
        this.recommendNewsTotalCount = res.total_count;
        if (this.itemData.length) {
          this.focusNewsList = this.focusNewsList.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    },
    getRecommendEventSetInterval(start) {
      if (this.eventTimerFunction) {
        clearTimeout(this.eventTimerFunction);
      }
      if (start) {
        this.eventTimerFunction = setTimeout(() => {
          if (this.eventRefreshCountDown > 0) {
            this.eventRefreshCountDown--;
          } else {
            // eslint-disable-next-line
            this.eventPageNum = 1;
            this.eventId = -1;
            this.eventRefreshCountDown = 60;
            if (this.eventSearchText) {
              this.getRecommendEventSearch(true);
            } else {
              this.eventHighLight = [];
              this.getRecommendEvent(true);
            }
          }
          this.getRecommendEventSetInterval(start);
        }, 1000);
      } else {
        this.eventRefreshCountDown = 60;
      }
    },
    eventAutoRefreshChange(res) {
      this.getRecommendEventSetInterval(res);
    },
    onEventAutoRefreshClick() {
      this.eventPageNum = 1;
      this.eventId = -1;
      this.eventLoading = true;
      if (this.eventSearchText) {
        this.eventRefreshCountDown = 60;
        this.getRecommendEventSearch(true);
      } else {
        this.eventHighLight = [];
        this.eventRefreshCountDown = 60;
        this.getRecommendEvent(true);
      }
    },
    onTabChange(item) {
      this.selectedOptionTab = item;
      if (this.selectedOptionTab === '事件细闻') {
        this.$router.push({
          path: '/',
          query: {
            type: 'news'
          }
        });
        this.getLatestImportantNewsSetInterval(false);
        this.getRecommendEventSetInterval(false);
        this.importantNewsSearchText = '';
        this.earliestNewsId = -1;
        this.earliestDateNum = -1;
        this.latestDateNum = -1;
        this.itemData = [];
        this.focusNewsList = [];
        this.importantNewsHighLight = [];
        this.recommendNewsTotalCount = -1;
        this.getFirstEarliestImportantNews();
      } else {
        this.$router.push({
          path: '/'
        });
        this.getRecommendEventSetInterval(false);
        this.getLatestImportantNewsSetInterval(false);
        this.importantNewsSearchText = '';
        this.earliestNewsId = -1;
        this.pageNum = 1;
        this.latestNewsId = -1;
        this.itemData = [];
        this.focusNewsList = [];
        this.importantNewsHighLight = [];
        this.eventSearchText = '';
        this.option = 'min_publish_date';
        this.eventId = -1;
        this.eventPageNum = 1;
        this.eventItemData = [];
        this.eventList = [];
        this.eventHighLight = [];
        this.recommendEventTotalCount = -1;
        this.getRecommendEvent(false);
        this.eventAutoRefreshChange(this.eventAutoRefresh);
      }
    },
    loadMoreEvent() {
      this.eventBusy = true;
      if (this.eventTimer) {
        clearTimeout(this.eventTimer);
      }
      if (this.eventItemData.length) {
        if (this.eventSearchText) {
          this.eventTimer = setTimeout(() => {
            this.eventPageNum++;
            this.getRecommendEventSearch(false);
          }, 500);
        } else {
          this.eventTimer = setTimeout(() => {
            this.eventPageNum++;
            this.getRecommendEvent(false);
          }, 500);
        }
      }
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.itemData.length) {
        if (this.importantNewsSearchText) {
          this.timer = setTimeout(() => {
            this.pageNum++;
            this.getRecommendImportantNewsSearch();
          }, 500);
        } else {
          this.timer = setTimeout(() => {
            this.getEarliestImportantNews();
          }, 500);
        }
      }
    },
    onEventOptionChange(res) {
      this.option = res;
      this.eventId = -1;
      this.eventPageNum = 1;
      this.eventItemData = [];
      this.eventList = [];
      if (this.eventSearchText) {
        this.eventRefreshCountDown = 60;
        this.getRecommendEventSearch(false);
      } else {
        this.eventHighLight = [];
        this.eventRefreshCountDown = 60;
        this.getRecommendEvent(false);
      }
    },
    getRecommendEvent(getData = false) {
      this.isLoading = true;
      QuestionQuery.getRecommendEvent(this.eventPageNum, this.eventPageSize, this.option, this.eventId).then(
        res => {
          if (this.eventLoading) {
            this.eventLoading = false;
          }
          this.isLoading = false;
          if (res.length) {
            if (getData) {
              this.eventItemData = [];
              this.eventList = [];
            }
            this.eventItemData = res.map(item => {
              return {
                heat: item.heat,
                title: item.title,
                count: item.count,
                firstTime: item.min_publish_date,
                lastTime: item.max_publish_date,
                eventId: item.event_id,
                sentiment: item.sentiment,
                companies: item.companies
              };
            });
            this.eventId = res[res.length - 1].event_id;
            for (let i = 0; i < this.eventItemData.length - 1; i++) {
              for (let j = i + 1; j < this.eventItemData.length; j++) {
                if (this.eventItemData[i].title === this.eventItemData[j].title) {
                  this.eventItemData[i].companies = this.eventItemData[i].companies.concat(this.eventItemData[j].companies);
                  for (let x = 0; x < this.eventItemData[i].companies.length - 1; x++) {
                    for (let y = x + 1; y < this.eventItemData[i].companies.length; y++) {
                      if (this.eventItemData[i].companies[x].name === this.eventItemData[i].companies[y].name) {
                        this.eventItemData[i].companies.splice(y, 1);
                        y--;
                      }
                    }
                  }
                  this.eventItemData.splice(j, 1);
                  j--;
                }
              }
            }
            for (let m = 0; m < this.eventList.length - 1; m++) {
              for (let n = 0; n < this.eventItemData.length - 1; n++) {
                if (this.eventList[m].title === this.eventItemData[n].title) {
                  this.eventItemData.splice(n, 1);
                  n--;
                }
              }
            }
            this.eventList = this.eventList.concat(this.eventItemData);
            this.eventBusy = false;
          } else {
            this.eventItemData = [];
            this.eventBusy = true;
          }
        },
        () => {
          this.getRecommendEventSetInterval(false);
          this.isLoading = false;
        }
      );
    },
    getEarliestImportantNews() {
      const params = {
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        pageSize: this.pageSize
      };
      this.isLoading = true;
      QuestionQuery.getEarliestImportantNews(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.recommendNewsTotalCount = res.total_count;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.focusNewsList = this.focusNewsList.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    },
    getFirstEarliestImportantNews() {
      const params = {
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        pageSize: this.pageSize
      };
      this.isLoading = true;
      QuestionQuery.getEarliestImportantNews(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.recommendNewsTotalCount = res.total_count;
        if (this.itemData.length) {
          this.latestDateNum = res.result[0].dateNum;
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.focusNewsList = this.focusNewsList.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
        this.getLatestImportantNewsSetInterval(true);
      });
    },
    getLatestImportantNewsSetInterval(start) {
      if (this.timer1) {
        clearTimeout(this.timer1);
      }
      if (start) {
        this.timer1 = setTimeout(() => {
          this.getLatestImportantNews();
          this.getLatestImportantNewsSetInterval(start);
        }, 1000 * 20);
      }
    },
    getLatestImportantNews() {
      const params = {
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestDateNum,
        pageSize: this.pageSize
      };
      QuestionQuery.getEarliestImportantNews(params).then(
        res => {
          if (res.result.length) {
            this.latestDateNum = res.result[0].dateNum;
            if (this.importantNewsDoc.scrollTop >= 0 && this.importantNewsDoc.scrollTop <= 300) {
              this.showImportantNewsUnread = false;
              this.importantNewsDoc.scrollTop = 0;
              this.focusNewsList.unshift(...res.result);
            } else {
              this.showImportantNewsUnread = true;
              this.latestImportantNewsData = this.latestImportantNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestImportantNewsSetInterval(false);
        }
      );
    },
    onShowImportantNewMessage() {
      this.showImportantNewsUnread = false;
      if (this.latestImportantNewsData.length >= 50) {
        this.focusNewsList.unshift(...this.latestImportantNewsData);
        this.latestImportantNewsData = [];
        this.importantNewsDoc.scrollTop = 0;
      } else {
        this.focusNewsList.unshift(...this.latestImportantNewsData);
        this.latestImportantNewsData = [];
        this.latestImportantNewsTimer = setInterval(() => {
          if (this.importantNewsDoc.scrollTop) {
            this.importantNewsDoc.scrollTop = this.importantNewsDoc.scrollTop - 200;
          } else if (!this.importantNewsDoc.scrollTop || this.importantNewsDoc.scrollTop < 0) {
            clearInterval(this.latestImportantNewsTimer);
          }
        }, 50);
      }
    }
  },
  components: {
    RecommendFocusNewsItem,
    RecommendEventNewsItem
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.recommend-focus-news-item-title'));
    const eventInstance = new Mark(document.querySelectorAll('.recommend-event-news-item-right-title-content'));
    instance.mark(this.importantNewsHighLight || [], {
      element: 'span',
      className: 'highlight'
    });

    eventInstance.mark(this.eventHighLight || [], {
      element: 'span',
      className: 'highlight'
    });
  },
  mounted() {
    this.importantNewsDoc = document.querySelector('.recommend-focus-news-list');
    if (this.$route.query.type) {
      this.selectedOptionTab = '事件细闻';
      this.getFirstEarliestImportantNews();
    } else {
      this.getRecommendEvent(false);
      this.eventAutoRefreshChange(true);
    }
  },
  beforeDestroy() {
    this.getLatestImportantNewsSetInterval(false);
    this.getRecommendEventSetInterval(false);
    if (this.latestImportantNewsTimer) {
      clearInterval(this.latestImportantNewsTimer);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.loading {
  margin: 0 auto;
  padding: 7px 0 27px 0;
  height: 10px;
  width: 100%;
  color: #747990;
  text-align: center;
}
.whole-network-tab {
  position: relative;
  justify-content: space-between;
  padding: 0 24px;
  height: 44px;
  line-height: 44px;
  width: 100%;
  color: #747990;
  background-color: #ffffff;
  font-size: 14px;
  box-shadow: inset 0px -1px 0px 0px#f2f3f7;
  .important-news-unread-message {
    position: absolute;
    top: 52px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 12px;
    height: 17px;
    background-color: #636772;
    border-radius: 2px;
    z-index: 1;
    cursor: pointer;
    .important-news-unread-count {
      margin-right: 4px;
      margin-top: -13px;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .tab-item {
    margin-right: 32px;
    cursor: pointer;
    &:hover {
      color: #45a8cc;
    }
  }
  .tab-item-active {
    color: #45a8cc;
  }
  .input-container {
    position: relative;
    .select {
      margin: 0 10px;
      width: 100px;
    }
    .search-img {
      position: absolute;
      width: 16px;
      top: 14px;
      left: 216px;
      cursor: pointer;
    }
    input {
      margin-top: 9px;
      width: 244px;
      height: 26px;
      padding: 3px 27px 3px 12px;
      font-size: 14px;
      border: solid 2px #f7f8fc;
      border-radius: 2px;
      background-color: #f7f8fc;
      outline: none;

      // &:hover {
      //   border: solid 2px $hoverColor;
      // }

      // &:focus {
      //   border: solid 2px $activeColor;
      // }
    }
    // input[placeholder] {
    //   color: $color !important;
    // }
    input::-webkit-input-placeholder {
      color: #9ea1b4;
    }
    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #9ea1b4;
    }
    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #9ea1b4;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #9ea1b4;
    }
    .event-refresh-title {
      margin-left: 4px;
      .event-refresh-title-count {
        display: inline-block;
        width: 17px;
        color: #45a8cc;
      }
    }
    .refresh-icon-loading {
      margin-left: 10px;
      width: 16px;
      height: 16px;
      margin-top: 14px;
    }
    .refresh-icon {
      margin-left: 10px;
      width: 16px;
      height: 16px;
      margin-top: 14px;
      cursor: pointer;
    }
  }
}
.recommend-focus-news-list {
  position: relative;
  // overflow: auto;
  height: calc(100vh - 124px);
  overflow: auto;
  padding: 0 24px;
  background-color: #ffffff;
  .recommend-no-data-img {
    position: absolute;
    top: 176px;
    left: 50%;
    transform: translateX(-50%);
  }
  .recommend-no-data-word {
    position: absolute;
    top: 268px;
    left: 50%;
    transform: translateX(-50%);
    color: #9ea1b4;
    font-size: 14px;
  }
}
.recommend-event-news-list-no-data {
  background-color: #ffffff;
}
.recommend-event-news-list {
  position: relative;
  // overflow: auto;
  height: calc(100vh - 124px);
  overflow: auto;
  .recommend-event-news-item-container {
    margin-top: 10px;
    padding: 16px 16px;
  }
  .recommend-no-data-img {
    position: absolute;
    top: 176px;
    left: 50%;
    transform: translateX(-50%);
  }
  .recommend-no-data-word {
    position: absolute;
    top: 268px;
    left: 50%;
    transform: translateX(-50%);
    color: #9ea1b4;
    font-size: 14px;
  }
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none !important;
  border-radius: 2px;
  color: #464d6c;
  background-color: #f7f8fc !important;
  &:hover {
    background-color: #eaebef !important;
  }
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}
// .focus-list-move {
//   transition: all 1s;
//   display: inline-block;
// }
// .focus-list-enter, .focus-list-leave-to
// /* .list-leave-active for below version 2.1.8 */ {
//   opacity: 0;
// }
.focus-list-enter-active,
.focus-list-leave-active {
  transition: all 1s;
}
.focus-list-enter, .focus-list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>
